var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"cl-color-dark pl-5"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"pa-5",attrs:{"id":"doc"}}),_c('Carregando',{attrs:{"role":"alert","id":"carregando"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }